<template>
  <div class="ev-page-container ev-page-container--wide">
    <!-- edit employee modal -->
    <modal
      name="edit-employee-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-employee
        :selectedEmployee="selectedEmployee"
        :departments="departments"
        :shifts="shifts"
        :isSaveAndProceedButtonVisible="false"
        title="UREDI ZAPLOSENOG"
        @saveAndCloseClicked="editEmployee"
        @departmentChangeRequested="changeDepartment"
      />
    </modal>

    <!-- add employee modal -->
    <modal
      name="add-employee-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-employee
        :selectedEmployee="selectedEmployee"
        :departments="departments"
        :shifts="shifts"
        :isSaveAndProceedButtonVisible="true"
        title="DODAJ ZAPOSLENOG"
        @saveAndCloseClicked="addEmployee"
        @saveAndProceedClicked="addEmployeeAndContinue"
      />
    </modal>

    <!-- delete employee modal -->
    <modal
      name="delete-employee-modal"
      :adaptive="true"
      :reset="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <delete-item
        message="Da li zaista žekite da obrišete zaposlenog"
        title="OBRIŠI ZAPOSLENOG"
        :selectedItem="selectedEmployee"
        @deleteButtonClicked="deleteEmployee"
      />
    </modal>

    <!-- add user modal -->
    <modal
      name="add-user-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-user
        :selectedUser="selectedUser"
        :selectingEmployeeDisabled="false"
        :addOrEdit="true"
        :isSaveAndProceedButtonVisible="false"
        title="Dodaj korisnika aplikacije"
        @saveAndCloseClicked="addUser"
      />
    </modal>

    <!-- Page Header -->
    <div class="ev-page-header">
      <h1 class="ev-page-title">
        <span class="ev-title-icon">👥</span>
        Zaposleni
      </h1>
      <p class="ev-page-subtitle">Administracija zaposlenih u preduzeću</p>
    </div>

    <!-- Table Section -->
    <div class="ev-table-section">
      <div class="ev-table-header">
        <h3 class="ev-table-title">
          <span class="ev-table-icon">📋</span>
          Lista zaposlenih
        </h3>
        <div class="header-actions">
          <a @click="toggleActive" class="toggle-link">{{
            stringOnlyActive
          }}</a>
        </div>
      </div>
      <div class="ev-table-container">
        <vue-good-table
          theme="polar-bear"
          :columns="columns"
          :rows="rows"
          styleClass="vgt-table striped"
          :group-options="{
            enabled: true,
          }"
          :search-options="{
            enabled: true,
            searchFn: searchFunc,
            placeholder: 'Pretraži zaposlene...',
          }"
        >
          <template slot="table-header-row" slot-scope="props">
            <span class="group-header">
              <h2 class="group-title">
                {{ props.row.label }}
              </h2>
            </span>
          </template>
          <template slot="table-row" slot-scope="props">
            <span
              v-if="props.column.field == 'before'"
              class="ev-action-buttons"
            >
              <!-- edit icon -->
              <button
                class="ev-action-btn ev-action-btn-edit"
                v-show="props.row.isnew === false"
                @click="editRow(props.row)"
                title="Uredi"
              >
                <font-awesome-icon icon="edit" />
              </button>
              <!-- Full edit icon -->
              <button
                class="ev-action-btn ev-action-btn-info"
                v-show="props.row.isnew === false"
                @click="fullEditRow(props.row)"
                title="Detalji"
              >
                <font-awesome-icon icon="user-circle" />
              </button>
              <!-- delete icon -->
              <button
                class="ev-action-btn ev-action-btn-delete"
                v-show="props.row.isnew === false"
                @click="deleteRow(props.row)"
                title="Obriši"
              >
                <font-awesome-icon icon="trash-alt" />
              </button>
              <!-- add new row button -->
              <button
                class="ev-btn ev-btn-primary"
                v-show="props.row.isnew === true"
                @click="addRow(props.row)"
              >
                <font-awesome-icon icon="plus" />
                Dodaj zaposlenog
              </button>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "../../services/user.service";
import EditEmployee from "../parts/EditEmployee.vue";
import DeleteItem from "../parts/DeleteItem.vue";
import EditUser from "../parts/EditUser.vue";
import "vue-good-table/dist/vue-good-table.css";
import "vue-select/dist/vue-select.css";
import { VueGoodTable } from "vue-good-table";
import { EmployeeFront, EmployeeBack } from "../../models/employee.js";
import { UserBack, UserFront } from "../../models/user";

export default {
  components: {
    VueGoodTable,
    EditEmployee,
    DeleteItem,
    EditUser,
  },
  name: "Employees",
  data() {
    return {
      showOnlyActive: true,
      stringOnlyActive: "prikaži i neaktivne radnike",
      selectedEmployee: {
        department: {
          name: null,
          id: null,
          shiftId: null,
        },
      },
      selectedUser: {},
      departments: [],
      columns: [
        {
          label: "Id broj",
          field: "employeeId",
          type: "number",
          sortable: false,
        },
        {
          label: "Ime",
          field: "firstName",
          sortable: false,
        },
        {
          label: "Prezime",
          field: "lastName",
          sortable: false,
        },
        {
          label: "Status",
          field: "status",
          type: "boolean",
          // filterOptions: {
          //   styleClass: "class1", // class to be added to the parent th element
          //   enabled: true, // enable filter for this column
          //   placeholder: "Filter This Thing", // placeholder for filter input
          //   filterValue: "true", // initial populated value for this filter
          //   filterDropdownItems: [], // dropdown (with selected values) instead of text input
          //   filterFn: this.columnFilterFn, //custom filter function that
          //   trigger: "enter", //only trigger on enter not on keyup
          // },
          sortable: false,
        },
        {
          label: "Sektor",
          field: "department.name",
          sortable: false,
        },
        {
          label: "Index poretka",
          field: "remoteId",
          sortable: false,
        },
        {
          label: "Akcije",
          field: "before",
          sortable: false,
        },
      ],
      rows: [],
      errorMessage: "",
      shifts: [],
    };
  },

  mounted() {
    this.getDepartments();
    this.getShifts();
  },

  methods: {
    collectErrorMessage(error) {
      let msg =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      return msg;
    },
    resetUi() {
      this.departments = [];
      this.rows = [];
    },
    searchFunc(row, col, cellValue, searchTerm) {
      if (typeof cellValue === "string" || cellValue instanceof String) {
        return cellValue.toLowerCase().includes(searchTerm.toLowerCase());
      } else if (cellValue == null) {
        return true;
      }
    },
    resetSelectedEmployer() {
      this.selectedEmployee = {
        department: {
          name: null,
          id: null,
          shiftId: null,
        },
      };
    },
    getShifts() {
      UserService.getShifts().then((response) => {
        console.log(response);
        response.data.forEach((shift) => {
          this.shifts.push({
            id: shift.shiftId,
            name: shift.name,
          });
        });
      });
    },
    getDepartments() {
      UserService.getDepartments().then((response) => {
        // reset ui
        this.resetUi();

        // get new data
        response.data.forEach((element) => {
          // populate departments
          this.departments.push({
            name: element.name,
            id: element.departmentId,
            shiftId: element.shiftId,
          });

          // populate rows
          let newEmployees = [];
          element.employee.forEach((employee) => {
            let emp = new EmployeeFront(employee);
            emp.updateDepartment(
              element.departmentId,
              element.name,
              element.shiftId
            );
            if (this.showOnlyActive) {
              if (emp.status) {
                newEmployees.push(emp);
              }
            } else {
              newEmployees.push(emp);
            }
          });
          let newRow = {
            mode: "span",
            label: element.name + " (id:" + element.departmentId + ")",
            html: false,
            children: newEmployees,
          };
          newRow.children.push(
            new EmployeeFront({
              employeeId: null,
              firstName: null,
              lastName: null,
              status: null,
              department: {
                name: null,
                id: null,
                shiftId: null,
                hiddenId: element.departmentId,
                hiddenName: element.name,
                hiddenShiftId: element.shiftId,
              },
              accessGroupId: null,
              isnew: true,
            })
          );
          this.rows.push(newRow);
        });
      });
    },
    editRow(emp) {
      this.selectedEmployee = emp;
      this.$modal.show("edit-employee-modal");
    },
    deleteRow(emp) {
      this.selectedEmployee = emp;
      this.$modal.show("delete-employee-modal");
    },
    fullEditRow(emp) {
      this.selectedEmployee = emp;
      this.$router.push("/user/editemployeefull?employeeId=" + emp.employeeId);
    },
    addRow(emp) {
      this.selectedEmployee = emp;
      // every employee should have accessGroupId = 2
      console.log("employee");
      console.log(emp);
      emp.accessGroupId = 2;
      emp.status = true;
      emp.department.id = emp.department.hiddenId;
      emp.department.name = emp.department.hiddenName;
      emp.department.shiftId = emp.department.hiddenShiftId;
      this.$modal.show("add-employee-modal");
    },
    editEmployee(employee) {
      console.log(employee);
      let employeeToEdit = new EmployeeBack(employee);
      console.log(employeeToEdit);

      // Check if this is a department change request
      if (
        employee.changeDepartment &&
        employee.newDepartmentId &&
        employee.changeDate
      ) {
        this.changeDepartment({
          employeeId: employee.employeeId,
          newDepartmentId: employee.newDepartmentId,
          changeDate: employee.changeDate,
        });
        return;
      }

      UserService.putEmployee(employeeToEdit).then(
        () => {
          // reload ui
          this.resetUi();

          this.getDepartments();
        },
        (error) => {
          this.errorMessage = this.collectErrorMessage(error);
        }
      );

      this.$modal.hide("edit-employee-modal");
    },

    changeDepartment(departmentChangeData) {
      console.log(
        "Department change requested with data:",
        departmentChangeData
      );

      // Use the UserService instead of direct axios call
      UserService.changeDepartment(departmentChangeData).then(
        (response) => {
          if (response.data && response.data.success) {
            // Show success message
            console.log("Department changed successfully");

            // Reload data
            this.resetUi();
            this.getDepartments();
          } else {
            // Replace Buefy toast with alert
            alert("Greška pri promjeni sektora");
          }

          this.$modal.hide("edit-employee-modal");
        },
        (error) => {
          this.errorMessage = this.collectErrorMessage(error);
          // Replace Buefy toast with alert
          alert(this.errorMessage);
        }
      );
    },

    deleteEmployee() {
      let employeeToDelete = new EmployeeBack(this.selectedEmployee);

      UserService.deleteEmployee(employeeToDelete).then(
        () => {
          // reload depts
          this.resetUi();

          this.getDepartments();
        },
        (error) => {
          this.errorMessage = this.collectErrorMessage(error);
        }
      );
      this.$modal.hide("delete-employee-modal");
    },
    addEmployeeAndContinue(employee, generateUser) {
      // If user should be generated for this user?
      // console.log(employee.hasUser);

      // create new employer
      let newEmployee = new EmployeeBack(employee);

      console.log(newEmployee);

      // upload
      // call axios
      UserService.postEmployee(newEmployee).then(() => {
        this.getDepartments();

        // reset ui
        let id = this.selectedEmployee.department.id;
        let name = this.selectedEmployee.department.name;
        this.resetSelectedEmployer();

        // this.$modal.hide("add-employee-modal");
        this.selectedEmployee.department.id = id;
        this.selectedEmployee.department.name = name;

        // push this new employee to the state
        this.$store.dispatch("general/setDepartmentData");

        if (generateUser) {
          alert("Sad user");
          let usr = new UserFront({
            employeeId: this.selectedEmployee.employeeId,
          });
          this.postProcessUser(usr);
        }
      });
    },
    addEmployee(employee, generateUser) {
      // If user should be generated for this user?
      // console.log(employee.hasUser);

      // create new employer
      let newEmployee = new EmployeeBack(employee);
      console.log(newEmployee);

      // upload
      // call axios
      UserService.postEmployee(newEmployee).then(() => {
        this.getDepartments();

        // reset ui
        this.resetSelectedEmployer();

        this.$modal.hide("add-employee-modal");

        if (generateUser) {
          alert("Sad user");
          let usr = new UserFront({
            employeeId: this.selectedEmployee.employeeId,
          });
          this.postProcessUser(usr);
        }
      });
    },
    postProcessUser(usr) {
      this.selectedUser = usr;
      this.$modal.show("add-user-modal");
    },
    addUser(user) {
      // create new employer
      let newUser = new UserBack(user);

      // upload
      // call axios
      UserService.postUser(newUser).then(() => {
        // reset ui
        this.resetUi();

        this.getUsers();

        this.$modal.hide("add-user-modal");
      });
    },
    toggleActive() {
      console.log("toggling active!");
      console.log(this.showOnlyActive);
      this.showOnlyActive = !this.showOnlyActive;
      if (this.showOnlyActive) {
        this.stringOnlyActive = "prikaži i neaktivne radnike";
      } else {
        this.stringOnlyActive = "prikaži samo aktivne radike";
      }
      this.getDepartments();
    },
  },
};
</script>

<style scoped>
/* Component-specific styles */
.header-actions {
  display: flex;
  align-items: center;
}

.toggle-link {
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.15);
  transition: all 0.2s ease;
}

.toggle-link:hover {
  background: rgba(255, 255, 255, 0.25);
  color: white;
}

.group-header {
  display: block;
  padding: 8px 0;
}

.group-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--ev-primary-start, #667eea);
  margin: 0;
}
</style>
